import { a as appGlobalScript } from './ionic-global-fbc9a2ac.js';

const globalScripts = appGlobalScript;

export { globalScripts as g };
